import React from 'react';
import { CreateButton } from 'react-admin';
import { Box } from '@mui/material';

const Empty = ({ icon: Icon, title, description }) => (
    <Box textAlign="center" m={1}>
        <Icon sx={{ fontSize: 100, color: 'text.disabled' }} />
        <Box mt={2} mb={1} sx={{ fontSize: '1.5rem', fontWeight: 'bold' }}>
            {title}
        </Box>
        <Box mb={2} sx={{ color: 'text.secondary' }}>
            {description}
        </Box>
        <CreateButton />
    </Box>
);

export default Empty;
